window._ = {};
window.App = {
    each: require('lodash/fp/each'),
};
import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = $('meta[name="csrf-token"]').attr('content');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
import './sass/app.scss';
import $script from './include';

window.$script = $script;
require('./jquery.debouncedresize');
$.event.special.debouncedresize.threshold = 300;

import Vue from 'vue/dist/vue';

App.vue = new Vue({
    el: '#app',
    data: {
        mobileMenuActive: false,
        modalChoosePoint: false,
        prices: {
            active: (typeof window.pricesIds === 'object') ? window.pricesIds[0] : 0,
        },
        works: [],
        workActiveCat: 16
    },
    computed: {
        worksVisible() {
            let visible = [];
            this.works.forEach(work => {
                if (+work.cat_id === this.workActiveCat) {
                    visible.push(work.id);
                }
            });
            return visible;
        }
    },
    methods: {
        menuGo(selector) {
            this.mobileMenuActive = false;
            jump(selector, {
                duration: 500,
                offset: -20,
                callback: undefined,
                a11y: false
            });
        },
        goHome() {
            window.location.href = '/';
        },
        openBooking(place) {
            App.map.places[place].booking.open();
            this.modalChoosePoint = false;
            try {
                if (place === 'kudrovo') {
                    yaCounter48397781.reachGoal('book_kudrovo');
                }
                if (place === 'okkervil') {
                    yaCounter48397781.reachGoal('book_okkervil');
                }
            } catch (e) {
                // --
            }
            return false;
        },
        openBookingShelgunova() {
            window.open('https://n172232.yclients.com/', '_blank').focus();
        },
        setWorksActiveCat(id) {
            this.workActiveCat = +id;
            App.gallery.swiper.updateSlides();
            App.gallery.swiper.update();
            setTimeout(() => { App.gallery.swiper.updateSlides(); }, 200);
        }
    },
    created() {
        this.works = window.worksJson;
    }
});
import fastclick from 'fastclick';

window.FastClick = fastclick.FastClick;
$(function () { FastClick.attach(document.body); });
import jump from 'jump.js';

window.jump = jump;
require('lazysizes');
require('lazysizes/plugins/unveilhooks/ls.unveilhooks');
document.addEventListener('lazybeforeunveil', function (e) {
    let bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});
App.menu = {};
App.menu.go = function (selector) {
    jump(selector, {
        duration: 1000,
        offset: 0,
        callback: undefined,
        a11y: false
    });
};
App.offers = {};
App.offers.swiper = false;
App.offers.init = function () {
    if (typeof Swiper === 'function') {
        App.offers.swiper = new Swiper('.offers-swiper-container', {
            direction: 'horizontal',
            slidesPerView: 3,
            spaceBetween: 0,
            loop: true,
            breakpoints: {
                400: {slidesPerView: 1},
                700: {slidesPerView: 1},
                1000: {slidesPerView: 2},
                1280: {slidesPerView: 3}
            },
            pagination: {
                el: '.offers-swiper-pagination',
                type: 'bullets',
                clickable: true
            },
        });
    }
};
App.about = {};
App.about.init = function () {
    if (typeof Swiper === 'function') {
        App.about.swiper = new Swiper('.about__sliderContainer', {
            direction: 'horizontal',
            loop: true,
            navigation: {
                nextEl: '.about-swiper-prev',
                prevEl: '.about-swiper-next'
            },
            pagination: {
                el: '.about-swiper-pagination',
                type: 'fraction',
            },
        });
    }
};
App.childroom = {};
App.childroom.init = function () {
    if (typeof Swiper === 'function') {
        App.childroom.swiper = new Swiper('.childroom__sliderContainer', {
            direction: 'horizontal',
            loop: true,
            navigation: {
                nextEl: '.childroom-swiper-prev',
                prevEl: '.childroom-swiper-next'
            },
            pagination: {
                el: '.childroom-swiper-pagination',
                type: 'fraction',
            },
        });
    }
};
App.gallery = {};
App.gallery.swiper = false;
App.gallery.init = function () {
    if (typeof Swiper === 'function') {
        App.gallery.swiper = new Swiper('.gallery-swiper-container', {
            updateOnImagesReady: true,
            direction: 'horizontal',
            slidesPerView: 3,
            slidesPerColumn: 1,
            spaceBetween: 5,
            uniqueNavElements: true,
            normalizeSlideIndex: true,
            loop: false,
            breakpoints: {
                400: {
                    slidesPerView: 1,
                    slidesPerColumn: 1
                },
                700: {
                    slidesPerView: 2,
                    slidesPerColumn: 1
                },
                1000: {
                    slidesPerView: 3,
                    slidesPerColumn: 1
                },
                1280: {
                    slidesPerView: 3,
                    slidesPerColumn: 1
                },
                2000: {
                    slidesPerView: 4,
                    slidesPerColumn: 1
                }
            },
            navigation: {
                nextEl: '.gallery-swiper-next',
                prevEl: '.gallery-swiper-prev'
            }
        });
    }
};
App.map = {
    places: {
        kudrovo: {
            coords: [59.866651, 30.459768],
            name_short: 'Шелгунова',
            address: 'Шелгунова улица, д.7',
            instance: false,
            booking: false
        },
        okkervil: {
            coords: [59.914786, 30.515052],
            name_short: 'Оккервиль',
            address: 'Ленинградская улица, д.7, корпус 2',
            instance: false,
            booking: false
        }
    },
    init() {
        $script(['https://api-maps.yandex.ru/2.1/?lang=ru_RU'], 'js_ymaps');
        $script.ready('js_ymaps', function () {
            ymaps.ready(() => {
                try {
                    App.map.instance = new ymaps.Map('map_place', {
                        center: [59.892676, 30.489394],
                        zoom: 11,
                        controls: ['zoomControl', 'fullscreenControl']
                    }, {
                        searchControlProvider: 'yandex#search'
                    });
                    App.map.setPoints();
                } catch (e) {
                    console.log('error loading ymaps' + e);
                }
            });
        });
    },
    setPoints() {
        for (let placeName in App.map.places) {
            App.map.places[placeName].instance = new ymaps.Placemark(App.map.places[placeName].coords,{
                balloonContentHeader: 'Акварель ' + App.map.places[placeName].name_short,
                balloonContentBody: 'Адрес: ' + App.map.places[placeName].address,
                hintContent: App.map.places[placeName].address,
            });
            App.map.instance.geoObjects.add(App.map.places[placeName].instance);
        }
    },
    showPoint: function (place_name) {
        let place = App.map.places[place_name];
        App.map.instance.setCenter(place.coords);
        place.instance.balloon.open();
    }
};
App.reviews = {
    countVisible: 5,
    loadMore() {
        axios.get(`/reviews/${App.reviews.countVisible}`).then(response => {
            $('.reviews__wrapper').append(response.data);
            App.reviews.countVisible += 5;
        });
    }
};
$(document).ready(function () {
    App.offers.init();
    App.about.init();
    App.gallery.init();
    App.childroom.init();
    App.map.init();
});
$(window).on('debouncedresize', function (event) {
    App.offers.swiper.updateAutoHeight();
    App.about.swiper.updateAutoHeight();
    App.gallery.swiper.updateAutoHeight();
    App.childroom.swiper.updateAutoHeight();
});
App.arnika = function (orgId) {
    var dataUrl = 'https://app.arnica.pro',
    initialized = false,
    iframeIsLoad = false,
    position = 'center',
    wrapper,
    iframe,
    layer,
    contain,
    loaderWrapper,
    loader,
    d = document,
    bodyOldStyle,
    htmlOldStyle;

    let body = function () {
        var buff = d.getElementsByTagName('body');
        return buff.item(0);
    }

    let html = function () {
        var buff = d.getElementsByTagName('html');
        return buff.item(0);
    }

    let getMaxZIndex = function () {
        var maxZIndex = 0;
        if (typeof document.querySelectorAll !== 'function') {
            return maxZIndex;
        }
        var tags = document.querySelectorAll('body *');
        for (var i = 0; i < tags.length; i++) {
            var element = tags.item(i);
            var zindex = document.defaultView.getComputedStyle(element, null).getPropertyValue('z-index');
            if (zindex != 'auto') {
                zindex = parseInt(zindex);
                if (zindex > maxZIndex) {
                    maxZIndex = zindex;
                }
            }
        }
        return maxZIndex;
    }

    let openIframe = function (url) {
        iframe = d.createElement('iframe');
        var setIframeAttributes = function () {
            iframe.setAttribute('style', 'width:100%;height:100%;border:none;');
        };
        iframe.setAttribute('src', url);
        iframe.setAttribute('id', 'iframe');
        setIframeAttributes();
        contain.appendChild(iframe);
        iframe.onload = function () {
            if (!iframeIsLoad) {
                contain.removeChild(loaderWrapper);
            }
            iframeIsLoad = true;
        };
    }

    let removeScrolls = function () {
        var h = html(),
        b = body();
        htmlOldStyle = h.getAttribute('style');
        bodyOldStyle = b.getAttribute('style');
        h.setAttribute('style', 'overflow: hidden !important');
        b.setAttribute('style', 'overflow: hidden !important');
    }

    let returnScrolls = function () {
        html().setAttribute('style', htmlOldStyle);
        body().setAttribute('style', bodyOldStyle);
    }

    let isMobile = function () {
        return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());
    }

    let addCssFile = function (fileName) {
        let link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = fileName;
        document.head.appendChild(link);
    };

    return {
        init: function () {
            if (!initialized) {
                addCssFile(dataUrl + '/booking/css/widget/style.css?' + Math.random());
                layer = document.createElement('div');
                layer.classList.add('arnica-layer', 'arnica-layer-hide');
                layer.setAttribute('style', 'z-index: ' + getMaxZIndex() + 1);
                contain = document.createElement('div');
                contain.classList.add('arnica-widget-wrapper', 'arnica-widget-wrapper-hide', 'arnica-widget-wrapper-' + position);
                contain.setAttribute('style', 'display:none; z-index: ' + getMaxZIndex() + 2);
                loaderWrapper = d.createElement('div');
                loaderWrapper.id = 'arnica-preloader';
                loader = d.createElement('div');
                loader.id = 'arnica-loader';
                loaderWrapper.appendChild(loader);
                contain.appendChild(loaderWrapper);
                body().appendChild(layer);
                body().appendChild(contain);
                initialized = true;
            }
        },
        open: function (pos) {
            if (pos) {
                position = pos;
                contain.classList.remove('arnica-widget-wrapper-left', 'arnica-widget-wrapper-right', 'arnica-widget-wrapper-center');
                contain.classList.add('arnica-widget-wrapper-' + position);
            }
            var self = this;
            if (isMobile()) {
                var win = window.open(this.getUrl(), '_blank');
                win.focus();
                return;
            }
            var closeListener = function (event) {
                if (event.data === 'CloseBookingFrame') {
                    self.close();
                    if (window.addEventListener) {
                        window.removeEventListener('message', closeListener, false);
                    } else {
                        window.detachEvent('onmessage', closeListener);
                    }
                }
            };
            removeScrolls();
            //contain.style.display = null;
            layer.classList.remove('arnica-layer-hide');
            layer.classList.add('arnica-layer-show');
            contain.classList.remove('arnica-widget-wrapper-hide');
            contain.classList.add('arnica-widget-wrapper-show');
            if (!iframeIsLoad) {
                openIframe(this.getUrl(true));
            }
            if (window.addEventListener) {
                window.addEventListener('message', closeListener, false);
            } else {
                window.attachEvent('onmessage', closeListener);
            }
            return false;
        },
        close: function () {
            layer.classList.remove('arnica-layer-show');
            layer.classList.add('arnica-layer-hide');
            contain.classList.remove('arnica-widget-wrapper-show');
            contain.classList.add('arnica-widget-wrapper-hide');
            returnScrolls();
            return false;
        },
        getUrl: function (flag) {
            return dataUrl + '/booking/booking?' +
            (flag ? 'from=site&' : '') + 'orgid=' + orgId;
        },
        getZIndex: function () {
            return getMaxZIndex() + 1;
        }
    };
};

$(document).ready(function () {
    // kudrovo
//    App.map.places.kudrovo.booking = App.arnika(35471);
//    App.map.places.kudrovo.booking.init();
    // okkervil
    App.map.places.okkervil.booking = App.arnika(36188);
    App.map.places.okkervil.booking.init();
});

$script(['https://vk.com/js/api/openapi.js?152'], 'js_vk');
$script.ready('js_vk', function () {
    VK.Widgets.CommunityMessages('vk_messages', 18023203, {
        disableExpandChatSound: '1',
        tooltipButtonText: 'Есть вопрос?',
        disableButtonTooltip: '0'
    });
});
